import { useIntl } from 'react-intl';

// ASSETS
import ReportedOdometerIcon from 'assets/reportedOdometerIcon';
import CalculatedOdometerIcon from 'assets/calculatedOdometerIcon';
import InfoIcon from 'assets/infoIcon';

// STYLES
import { OdometerTypePill, OdometerTypePillText, OdometerPillTooltip, InfoLink } from './styles';
import colors from 'styles/colors';

export const BaseTag = (props) => {
  const { icon, text, showInfoLink, tooltipText, className } = props;
  const intl = useIntl();

  const component = (
    <OdometerTypePill className={className}>
      {icon}
      <OdometerTypePillText>{text}</OdometerTypePillText>
      {showInfoLink && (
        <InfoLink
          href={intl.formatMessage({
            id: 'views.FleetSettings.Vehicles.Connectivity.learnMoreLink',
          })}
          target="_blank"
          rel="noopener"
        >
          <InfoIcon color={colors.fleetBlue} />
        </InfoLink>
      )}
    </OdometerTypePill>
  );

  return tooltipText ? (
    <OdometerPillTooltip trigger={component} content={tooltipText} position="top center" />
  ) : (
    component
  );
};

export const ReportedOdometerTag = (props) => {
  const intl = useIntl();
  const { showInfoLink = false, showTooltip = false } = props;
  return (
    <BaseTag
      className={props.className}
      tooltipText={
        showTooltip
          ? intl.formatMessage({
              id: 'services.Vehicles.reportedOdometerTooltip',
            })
          : undefined
      }
      showInfoLink={showInfoLink}
      icon={<ReportedOdometerIcon />}
      text={intl.formatMessage({ id: 'services.Vehicles.reportedOdometer' })}
    />
  );
};

export const CalculatedOdometerTag = (props) => {
  const intl = useIntl();
  const { showInfoLink = false, showTooltip = false } = props;
  return (
    <BaseTag
      className={props.className}
      tooltipText={
        showTooltip
          ? intl.formatMessage({
              id: 'services.Vehicles.calculatedOdometerTooltip',
            })
          : undefined
      }
      showInfoLink={showInfoLink}
      icon={<CalculatedOdometerIcon />}
      text={intl.formatMessage({ id: 'services.Vehicles.calculatedOdometer' })}
    />
  );
};
